module.exports = __webpack_public_path__ + "img/business6-1.5ab51e59.png";